export const PRODUCT_NAME = 'EightBots';
export const PRODUCT_ENTRY_LABEL = 'Meet Eightbots';
export const PAYMENT_EXAMPLE_LABEL = 'View payment example';
export const SUPPORT_EMAIL = 'support@eightbots.com';
